import {
    Log, LogLevel,
} from 'one-log';

import {
    init,
} from 'ccw-app';

import {
    loader,
} from 'one-web-loader';
import { enableTrace } from "one-trace";

import {
    AlertNotification
} from "one-alert-notification";

import {
    BrowserLogger,
} from 'one-web-logger';
import { HAServer, HAServerOne } from 'one-server-local-ha';
import * as React from 'react';
import { useEffect } from 'react';

// Declare Glia types
declare global {
    interface Window {
        getGliaApi: (config: { version: string }) => Promise<{
            EVENTS: {
                VISITOR_STATE: string;
                OPERATOR_STATE: string;
            };
            addBufferedEventListener: (event: string, callback: (data: any) => void) => void;
        }>;
    }
}

// Load Glia script
const loadGliaScript = () => {
    console.log('Starting to load Glia script...');
    return new Promise<void>((resolve, reject) => {
        if (document.querySelector('script[src="//libs.glia.com/axon.js"]')) {
            console.log('Glia script already exists, resolving...');
            resolve();
            return;
        }

        const script = document.createElement('script');
        script.src = '//libs.glia.com/axon.js';
        script.async = true;
        
        script.onload = () => {
            console.log('Glia script loaded successfully');
            resolve();
        };
        
        script.onerror = (error) => {
            console.error('Failed to load Glia script:', error);
            reject(error);
        };

        console.log('Appending Glia script to document head...');
        document.head.appendChild(script);
    });
};

// set up the logger
const log = new Log("ccw-app",[
    new BrowserLogger(),
],LogLevel.DEBUG);

loader({
    log,
    url: 'settings.json',
}, (options: any) => (
    new Promise(async (resolve) => {
        console.log('Loader callback started...');
        const {
            settings,
            resolver,
        } = options;

        /**
         * check for the log level config from settings and set default
         */
        const {logconfig,alertnotify} = settings;
        if(logconfig?.level==="INFO"){
            log.setlevel(LogLevel.INFO);
        } else  if(logconfig?.level==="WARN"){
            log.setlevel(LogLevel.WARN);
        } else  if(logconfig?.level==="ERROR"){
            log.setlevel(LogLevel.ERROR);
        } else{
            log.setlevel(LogLevel.DEBUG);
        }
        log.debug(
            'ccw-app-web',
            'app settings', {
            settings,
        });

          // logged in agent id
          const agentId = '761012';
          const agentLoginName = "AgentaDev21"
          const teamName="TeamLearn";
          // adding ani
          const ani = '';
          let alertnotification = new AlertNotification(false,alertnotify?.url,{
                             });
          if(alertnotify?.enable){
            alertnotification = new AlertNotification(true,alertnotify?.url,{
                userid:agentLoginName,
                team_name:teamName,
                customer_name:alertnotify?.customer,
                server_id:alertnotify?.servername,
              app_type:"web"
          })
          }
            // enable user specific trace
            enableTrace(agentId, {
                log,
                settings,
            });

        console.log('Initializing app...');
        // initialize the app
        const {
            store,
        } = await init('app', {
            log,
            agentId,
            ani,
            settings,
            resolver,
            agentLoginName,
            alertnotification,
            server: new HAServer(
                settings['servers'],
                (url:string,error: any) => {
                    store.dispatch({
                        type: "one-state-errorhandle/set",
                        payload: {
                            url: url,
                            error: error,
                            monitor: false
                        }
                    })
                }
            ),
            serverone: new HAServerOne(
                settings['servers'],
                (url:string,error: any) => {
                    store.dispatch({
                        type: "one-state-errorhandle/set",
                        payload: {
                            url: url,
                            error: error,
                            monitor: false
                        }
                    })
                }
            ),
        });

        console.log('App initialized, starting Glia integration...');

        // Initialize Glia after store is created
        try {
            console.log('Loading Glia script...');
            await loadGliaScript();
            
            console.log('Getting Glia API...');
            const glia = await window.getGliaApi({ version: 'v1' });
            console.log('Glia API obtained successfully');

            try {
                const user = await glia.getUser();
                console.log('Glia User Info:', user);
                if(user?.email) {
                    sessionStorage.setItem("GliaUser",user.email);
                    store.dispatch({
                        type: "one-state-getuserid/fetch",
                        payload: {
                          agentuserid: user.email,
                          
                        }
                      });
                }
            } catch (err) {
                console.error('Error while fetching Glia user:', err);
            }
            // Visitor state listener
            console.log('Setting up visitor state listener...');
            glia.addBufferedEventListener(glia.EVENTS.VISITOR_STATE, (visitorData: any) => {
                console.log('Visitor state event received:', visitorData);
                let callerani = "", callerdnis = "";
                if(visitorData?.siteId) {
                    sessionStorage.setItem("GliaInteractionID",visitorData.id)
                    store.dispatch({
                        type: "one-state-getsession/fetch",
                        payload: {
                            sessionKey:visitorData.siteId ? visitorData.id : null
                        }
                    });
                }
                if(visitorData?.phone?.length === 12) {
                    callerani = visitorData.phone.slice(2);
                    console.log('Processed caller ANI:', callerani);
                }
                else if (visitorData?.phone?.length === 10) {
                    callerani = visitorData.phone;
                    console.log('Processed caller ANI:', callerani);
                }
                if(visitorData?.customAttributes?.CalledNumber?.length === 12) {
                    callerdnis = visitorData.customAttributes.CalledNumber.slice(2);
                    console.log('Processed caller DNIS:', callerdnis);
                }
                else if(visitorData?.customAttributes?.CalledNumber?.length === 10) {
                    callerdnis = visitorData.customAttributes.CalledNumber;
                    console.log('Processed caller DNIS:', callerdnis);
                }
                if(visitorData?.phone) {
                    console.log('Dispatching choosecaller reset action...');
                    store.dispatch({
                        type: "one-state-choosecaller/set",
                        payload: {
                            number: callerani,
                            dnis: callerdnis,
                            visible: true,
                            start: true
                        }
                    });
                    console.log('Dispatching caller-patient action...');
                    // store.dispatch({
                    //     type: "caller-patient",
                    //     payload: {
                    //         number: callerani,
                    //         dnis: callerdnis
                    //     }
                    // });
                }
                console.log('Dispatching visitor state action...');
                store.dispatch({
                    type: "one-state-visitor/set",
                    payload: {
                        visitorData,
                        timestamp: new Date().toISOString()
                    }
                });
            });

            // Operator state listener
            console.log('Setting up operator state listener...');
            glia.addBufferedEventListener(glia.EVENTS.OPERATOR_STATE, (operatorState: any) => {
                console.log('Operator state event received:', operatorState);
                store.dispatch({
                    type: "one-state-operator/set",
                    payload: {
                        operatorId: operatorState.sender.id,
                        operatorState,
                        timestamp: new Date().toISOString()
                    }
                });
            });

            console.log('Glia integration completed successfully');
        } catch (error) {
            console.error('Failed to initialize Glia:', error);
        }

        console.log('Resolving loader...');
        resolve({
            log,
            // next is optional
            next: (params: any) => {
                console.debug(
                    'ccw-app-web',
                    'finished initialization...', {
                    params,
                });
                return Promise.resolve({
                    store,
                });
            },
        });
    })
));


